// Utility para generar data-cy attributes
export const dataCy = (selector, id) => {
  return `ec-${selector}-${id}`;
};

// Selectores comunes
export const SELECTORS = {
  BUTTON: 'button',
  LINK: 'a',
  LABEL: 'label',
  INPUT: 'input',
  DIV: 'div'
};